import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-059b72e0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};
var _hoisted_2 = {
  class: "title"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("Save List ");

var _hoisted_4 = {
  class: "high-text"
};
var _hoisted_5 = ["innerHTML", "onClick"];
var _hoisted_6 = {
  class: "text"
};
var _hoisted_7 = {
  class: "light-text"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode("Registration Number: ");

var _hoisted_9 = /*#__PURE__*/_createTextVNode("Credit Social Code: ");

var _hoisted_10 = ["innerHTML"];
import { apiRecordList, apiDel } from '@/api/information';
import { ref } from 'vue';
import { headers } from './data';
import { ElMessage } from 'element-plus';
import RiscernTable from '@/components/RiscernTable/index.vue';
import { useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var router = useRouter();
    var keywords = ref('');
    var subBtnLoading = ref(false);
    var tableData = ref({});
    var tableRef = ref(null);

    function getData(params) {
      var _tableRef$value;

      return (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 ? void 0 : _tableRef$value.getData(params);
    }

    function submitForm() {
      getData({
        searchKey: keywords.value
      });
    }

    function handleDelete(_ref) {
      var keyNo = _ref.keyNo;
      apiDel({
        keyNo: keyNo
      }).then(function (_ref2) {
        var data = _ref2.data;
        ElMessage.success('delete success!');
        getData();
      });
    } // 去详细信息


    function onHrefCompanyInfo(_ref3) {
      var keyNo = _ref3.keyNo;
      router.push({
        name: 'CompanyInfo',
        query: {
          key: keyNo
        }
      });
    }

    return function (_ctx, _cache) {
      var _component_el_table_column = _resolveComponent("el-table-column");

      var _directive_copy = _resolveDirective("copy");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(tableData.value.total), 1)])]), _createElementVNode("div", null, [_createVNode(RiscernTable, {
        api: _unref(apiRecordList),
        tableData: tableData.value,
        "onUpdate:tableData": _cache[0] || (_cache[0] = function ($event) {
          return tableData.value = $event;
        }),
        ref_key: "tableRef",
        ref: tableRef
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headers), function (tabItem) {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: tabItem.key,
              prop: tabItem.key,
              label: tabItem.title,
              width: tabItem.width
            }, _createSlots({
              _: 2
            }, [tabItem.htmlDomFunc ? {
              name: "default",
              fn: _withCtx(function (scope) {
                return [tabItem.canClick ? (_openBlock(), _createElementBlock(_Fragment, {
                  key: 0
                }, [_createElementVNode("div", {
                  innerHTML: tabItem.htmlDomFunc(scope.row),
                  class: "high-text--underline",
                  onClick: function onClick($event) {
                    return onHrefCompanyInfo(scope.row);
                  }
                }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, [scope.row.countryCode !== 86 ? (_openBlock(), _createElementBlock(_Fragment, {
                  key: 0
                }, [_hoisted_8], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                  key: 1
                }, [_hoisted_9], 64))]), _withDirectives((_openBlock(), _createElementBlock("span", null, [_createTextVNode(_toDisplayString(scope.row.entityNo), 1)])), [[_directive_copy, scope.row.entityNo]])])], 64)) : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "value",
                  innerHTML: tabItem.htmlDomFunc(scope.row)
                }, null, 8, _hoisted_10))];
              })
            } : tabItem.title === 'Action' ? {
              name: "default",
              fn: _withCtx(function (scope) {
                return [_createElementVNode("div", {
                  class: "high-text--underline",
                  onClick: function onClick($event) {
                    return handleDelete(scope.row);
                  }
                }, "Delete", 8, ["onClick"])];
              })
            } : undefined]), 1032, ["prop", "label", "width"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["api", "tableData"])])]);
    };
  }
});